import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Cliente } from '../models/cliente';

@Injectable({
  providedIn: 'root',
})
export class ClienteService {
  //Url da API

  private url = `${environment.apiUrl}/clientes`;

  constructor(private readonly http: HttpClient) {}

  selecionar(): Observable<Cliente[]> {
    return this.http.get<Cliente[]>(this.url);
  }

  cadastrar(obj: Cliente): Observable<Cliente> {
    return this.http.post<Cliente>(this.url, obj);
  }

  alterar(id: number, obj: Cliente): Observable<Cliente> {
    return this.http.put<Cliente>(`${this.url}`, obj);
  }

  remover(id: number): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }

  ativarDesativar(id: number, ativo: boolean = false): Observable<Cliente> {
    return this.http.patch<Cliente>(`${this.url}/${id}/ativo?ativo=${ativo}`, null as any);
  }

  pesquisar(search: string): Observable<Cliente[]> {
    return this.http.get<Cliente[]>(`${this.url}/nome/${search}`);
  }
}
